import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Twitter, Mail, Instagram, Facebook } from 'lucide-react';

const footerLinks = {
  company: [
    { name: 'nav.about', href: '/about' },
    { name: 'nav.services', href: '/services' },
    // { name: 'nav.investors', href: '/investors' }, // HIDDEN UNTIL LAUNCH
    { name: 'nav.contact', href: '/contact' },
    { name: 'Careers', href: '/careers' },
  ],
  legal: [
    { name: 'Terms of Service', href: '/terms' },
    { name: 'Privacy Policy', href: '/privacy' },
    { name: 'Cookie Policy', href: '/cookies' },
  ],
};

const socialLinks = [
  { name: 'Twitter', icon: Twitter, href: '#' },
  { name: 'Instagram', icon: Instagram, href: '#' },
  { name: 'Facebook', icon: Facebook, href: '#' },
  { name: 'Email', icon: Mail, href: 'mailto:contact@5n6.co.uk' },
];

export default function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-paper-darker" style={{ backgroundColor: '#E0DDD8' }}>
      <div className="container-wide py-12 lg:py-16">
        <div className="flex flex-col lg:flex-row lg:justify-between gap-8 lg:gap-12">
          {/* Brand */}
          <div style={{ marginTop: '-18px' }}>
            <Link to="/" className="inline-block">
              <div className="flex flex-col">
                <span className="font-logo tracking-tight text-ink text-[45px]">
                  5N6
                </span>
                <span className="text-xs text-ink-muted tracking-widest uppercase -mt-1">
                  {t('footer.madeIn')}
                </span>
              </div>
            </Link>
            <p className="mt-2 text-sm text-ink-light max-w-xs">
              {t('footer.tagline')}
            </p>
            <div className="mt-3 flex gap-4">
              {socialLinks.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="text-ink-muted hover:text-ink transition-colors"
                  aria-label={item.name}
                >
                  <item.icon size={20} />
                </a>
              ))}
            </div>
          </div>

          {/* Right columns group */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
            {/* Company Links */}
            <div>
              <h5 className="text-xs font-medium text-ink uppercase tracking-wider">
                {t('footer.company')}
              </h5>
              <ul className="mt-4 space-y-3">
                {footerLinks.company.map((item) => (
                  <li key={item.name}>
                    <Link
                      to={item.href}
                      className="text-sm text-ink-light hover:text-ink transition-colors"
                    >
                      {t(item.name)}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Legal Links */}
            <div>
              <h5 className="text-xs font-medium text-ink uppercase tracking-wider">
                {t('footer.legal')}
              </h5>
              <ul className="mt-4 space-y-3">
                {footerLinks.legal.map((item) => (
                  <li key={item.name}>
                    <Link
                      to={item.href}
                      className="text-sm text-ink-light hover:text-ink transition-colors"
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Company Info */}
            <div>
              <h5 className="text-xs font-medium text-ink uppercase tracking-wider">
                5N6 LTD
              </h5>
              <address className="mt-4 text-sm text-ink-light not-italic space-y-1">
                <p>5 Tivoli House</p>
                <p>Wigmore Park Centre</p>
                <p>Luton, Bedfordshire</p>
                <p>LU2 9DU</p>
                <p>United Kingdom</p>
              </address>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
      </div>
      <div style={{ backgroundColor: '#2a2a2a' }}>
        <div className="container-wide py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm" style={{ color: '#e0e0e0' }}>
              &copy; {currentYear} {t('footer.copyright')}
            </p>
            <p className="text-sm" style={{ color: '#e0e0e0' }}>
              5N6™ is a{' '}
              <a
                href="https://trademarks.ipo.gov.uk/ipo-tmcase/page/Results/1/UK00004090540"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition-colors underline"
              >
                registered trademark
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
